// extracted by mini-css-extract-plugin
module.exports = {"detail":"electricity-meter-detail_detail_3SYpj","listWrap":"electricity-meter-detail_listWrap_dJ7VY"};